define('shared/remote/efid/util',[
    '$',
    'shared/lib/RSVP',
    'shared/lib/URI', 
    'shared/page/wcmmode',
    'shared/my/accessToken/set',
    './const',
    './domain',
    'shared/my/efid',
    './cache'
], function(
    $,
    RSVP,
    URI, 
    getWCMMode,
    setAccessToken,
    constants,
    getEFIDDomain,
    efid,
    cache
){
    var $body = $('body');

    function getWindowMessageHandler(resolve, reject) {
        return function(evt) {
            if (typeof evt.data !== 'object') {
                return;
            }

            if (evt.data.type !== 'default.redirect.tokens') {
                return;
            }

            if (evt.data.tokens != null) {
                resolve(evt.data.tokens);
            }
            else {
                reject('Token cannot be found');
            }
        };
    }

    return {
        REGISTERED: 'registered-efid',
        getContinueURI: function(options) {
            var domain;

            return RSVP.resolve()
                .then(function () {
                    return getEFIDDomain();
                })
                .then(function (value) {
                    domain = value;                
                })
                .then(function(){
                    var uriContinue = new URI('');
                    uriContinue.host(domain);
                    uriContinue.scheme(constants.OAUTH2_SCHEME);
                    uriContinue.pathname('/' + [constants.OAUTH2_FOLDER, constants.OAUTH2_ACTION_AUTH].join('/'));
                    uriContinue.query({
                        response_type: 'token',
                        client_id: constants.OAUTH2_CLIENT_ID,
                        scope: constants.OAUTH2_SCOPE,
                        redirect_uri: location.origin + (
                                (options && options.defaultRedirect) ? 
                                constants.DEFAULT_REDIRECT : 
                                constants.CUSTOM_REDIRECT
                            )
                    });
                    return uriContinue;
                });
        },
        waitForAccessToken: function(continueURI){
            // the reason here we use iframe rather than XHR is because of 
            // 302 redirection is transparent to xhr and fetch (polyfill):
            // https://github.com/github/fetch/issues/137
            // so we can't read location header from the 302 response
            // also the access token info is part of hash which is 
            // only available to javascript that actually runs on the 
            // redirected page
            return new RSVP.Promise(function(rs, rj){
                function always(func) {
                    return function () {
                        var ctxt = this;
                        var args = arguments;

                        window.removeEventListener('message', handler);
                        $(iframe).remove();

                        return func.apply(ctxt, args);
                    };
                }

                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = continueURI;

                var handler = getWindowMessageHandler(always(rs), always(rj));
                window.addEventListener('message', handler);

                $body.append(iframe);
            })
            .then(function(data) {
                if (!data.id || !data.access) {
                    return null;
                }

                var efidValue = data.id.sub;
                return RSVP.all([setAccessToken(data.access), efid.set(efidValue), cache.set(efidValue, {
                        name:  {
                            given: data.id.given_name,
                            family: data.id.family_name
                        },
                        email: data.id.email
                    })])
                    .then(function(){
                        return data;
                    });
            });
        },
        oAuthPost: function(method, headers, data) {
            return RSVP.resolve()
                .then(function () {
                    return getEFIDDomain();
                })
                .then(function (domain) {
                    var uriCreate = new URI('');
                    uriCreate.host(domain);
                    uriCreate.scheme(constants.OAUTH2_SCHEME);
                    if (method.indexOf('/') !== 0) {
                        uriCreate.pathname('/' + [constants.OAUTH2_FOLDER, method].join('/'));
                    }
                    else {
                        uriCreate.pathname(method);
                    }
                    return $.ajax({
                        url: uriCreate.toString(),
                        method: 'POST',
                        traditional: true,
                        data: data,
                        dataType: 'json',
                        headers: headers,
                        crossDomain: true
                    })
                    .promise();
                });
        }
    };
});
